import { render, staticRenderFns } from "./new.data-loader.page.vue?vue&type=template&id=a10dea3e&"
import script from "./new.data-loader.page.vue?vue&type=script&lang=js&"
export * from "./new.data-loader.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports